<template>
  <div class="product-form-container">
    <!-- 基础信息区域 -->
    <baseInfo ref="baseInfoRef"></baseInfo>
    <saleInfo ref="saleInfoRef"></saleInfo>
    <detailInfo ref="detailInfoRef"></detailInfo>
    <logisticsInfo ref="logisticsInfoRef"></logisticsInfo>
    <!-- 表单按钮 -->
    <el-row type="flex" justify="center" style="margin: 30px 0">
      <el-button type="primary" size="medium" @click="handleSubmit">提交保存</el-button>
      <!-- <el-button size="medium" @click="consoleLogData">控制台输出</el-button> -->
    </el-row>
    <div class="empty-block"></div>
  </div>
</template>

<script>
//eslint-disable-next-line
import { mapMutations } from 'vuex'
import { onlinesGoodsCreatev, onlinesGoodsUpdate } from "@/api/onlines/goods.js";
import baseInfo from './components/baseInfo.vue';
import saleInfo from './components/saleInfo.vue';
import detailInfo from './components/detailInfo.vue';
import logisticsInfo from './components/logisticsInfo.vue';
export default {
  name: 'ProductForm',
  components: {
    baseInfo,
    saleInfo,
    detailInfo,
    logisticsInfo
  },
  data() {
    // 原始数据（严格按你提供的格式）
    return {
      formData: {},
      key: "create"
    };
  },
  computed: {
  },
  created() {
    this.key = this.$route.params.key;
    if (this.$route.params.value) {
      this.formData = JSON.parse(this.$route.params.value);
      this.$nextTick(() => {
        this.setRefValue(this.formData);
      }, 5000)
    }
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS", "CLEARTABS", "ADDTABS", "REMOVETABS"]),
    /* eslint-disable */
    setRefValue(d) {

      const base_info = {
        guid: d.guid,
        goods_tags: JSON.parse(d.goods_tags), //商品标签
        lable_content: d.lable_content, //商品简介
        goods_name: d.goods_name, //商品名称
        item_no: d.item_no, //货号
        class_no: d.class_no, //分类编号
        brand_name: d.brand_name || "", //品牌
        product_area: d.product_area
      }
      this.$refs.baseInfoRef.setValue(base_info);
      const sale_info = {
        guid: d.guid,
        barcode: d.barcode ?? "",
        is_default: d.is_default ?? true,
        has_spec: d.has_spec, //是否有规格
        sale_price: d.sale_price, //实际售价
        market_price: d.market_price, //市场价
        cost_price: d.cost_price, //成本价
        stock: d.stock, //库存数量
        stock_warning: d.stock_warning, //库存数量预警
        weight: d.weight, //重量
        volume: d.volume, //体积
        spec_json: JSON.parse(d.spec_json) ?? {}
      }
      this.$refs.saleInfoRef.setValue(sale_info);

      const detail_info = {
        goods_label: d.goods_label,
        banner: JSON.parse(d.banner),
        attribute_json: JSON.parse(d.attribute_json) ?? {}
      }
      this.$refs.detailInfoRef.setValue(detail_info);
      const other_info = {
        shipping_fee_type: Number(d.shipping_fee_type),
        shipping_fee: d.shipping_fee,
        shipping_template_id: d.shipping_template_id,
        is_on_sale: d.is_on_sale === "True" ? true : false,
        is_new: d.is_new === "True" ? true : false,
        is_hot: d.is_hot === "True" ? true : false,
        is_recommend: d.is_recommend === "True" ? true : false,
        sort_order: d.sort_order
      }
      this.$refs.logisticsInfoRef.setValue(other_info);
    },
    // 规格明细行操作
    addSpecRow() {
    },

    // 提交
    async handleSubmit() {

      /* this.$router.push({ name: 'goodsUpload', params: { key: 'update', value: JSON.stringify(row) } });
      this.ADDTABS({
        activePath: "/goodsUpload",
        title: "商品详情"
      }); */
      console.log("key===============111111111111111111111111", this.$refs.saleInfoRef.getValue());
      const detail_info = this.$refs.detailInfoRef.getValue();
      const data = {
        ...this.$refs.baseInfoRef.getValue(),
        ...this.$refs.saleInfoRef.getValue(),
        ...detail_info,
        brand_name: this.$refs.baseInfoRef.getValue().brand_name || "",
        banner: detail_info.banner.map((item, index) => {
          return {
            url: item.media_no ? item.media_no : item.url,
            sort: index
          }
        }),
        ...this.$refs.logisticsInfoRef.getValue()
      }
      delete data.barcode;
      console.log("data--------------ccccccccccccccccccccccccccc", data);
      console.log("data--------------ccccccccccccccccccccccccccc", this.key);
      if (this.key === "create" || !this.key) {
        const res = await onlinesGoodsCreatev(data);
        console.log("res-----------", res);
        this.$refs.saleInfoRef.generateSku(res.guid);
        if (res.state === true) {
          this.successMessage(res.message);
          this.$router.push("/goodsUpload");
          this.UPDATEMENUTABS("/goodsUpload");
          this.REMOVETABS("/goodsUpload");
        }
      } else if (this.key === "update") {
        const result = await onlinesGoodsUpdate(data);
        if (result.state === true) {
          this.successMessage(result.message);
          this.$router.push("/goodsUpload");

          this.UPDATEMENUTABS("/goodsUpload");
          this.REMOVETABS("/goodsUpload");
        }
      }

    }
  },
  watch: {
    // 当spec_json变化时更新文本域
    'formData.spec_json': {
      handler(val) {
        this.specJsonText = JSON.stringify(val, null, 2);
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="less">
.product-form-container {
  padding: 0 !important;
  margin: 0 !important;
  width: 99%;
}

.form-card {
  /* margin-bottom: 20px; */
  border-radius: 6px;
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 10px !important;
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
}

.card-header i {
  margin-right: 8px;
  color: #409EFF;
}

.field-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}

.html-preview-box {
  margin-top: 12px;
  padding: 10px;
  background-color: #fafafa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.preview-label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.html-preview {
  padding: 10px;
  background: white;
  border: 1px dashed #dcdfe6;
}

/* .html-preview >>> .product-desc ul {
  padding-left: 20px;
} */
</style>